import VideoPlaceholder from './VideoPlaceholder';
export default VideoPlaceholder;